<template>
  <div class="d-flex flex-column">
    <div  class="index-container top sticky-top">
      <a href="#top" class="index smoothscroll">▲</a>
      <a
        v-for="index in indices"
        :key="index.val"
        class="index"
        :class="index.items.length < 1 ? 'empty' : ''"
        :href="hrefForIndex(index)"
      >
        {{ index.val }}
      </a>
      <a href="#agency-list-bottom" class="index smoothscroll">▼</a>
      <div class="count desktop-only" style="float:right">Showing {{list.length}}</div>
    </div>
    <div class="list-container flex-grow-1" id="agency-list-top">
      <div
        class="list-item"
        v-for="member in sortedList"
        :key="member.id"
        :id="'agency-' + member.id"
      >
        <Member :member="member" />
      </div>
      <div id="agency-list-bottom"></div>
    </div>
    <div v-show="list.length > 10" class="index-container bottom">
      <a href="#top" class="index smoothscroll">▲</a>
      <a
        v-for="index in indices"
        :key="index.val"
        class="index"
        :class="index.items.length < 1 ? 'empty' : ''"
        :href="hrefForIndex(index)"
      >
        {{ index.val }}
      </a>

      <a href="#agency-list-bottom" class="index smoothscroll">▼</a>
      <div class="count desktop-only" style="float:right">Showing {{list.length}}</div>
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash'
import Member from './Member'

export default {
  props: {
    list: {
      type: Array,
    },
  },
  components: {
    Member,
  },
  computed: {
    sortedList() {
      return orderBy(this.list, (item) => {
        const name = item.name
        if (name[0].toUpperCase() === name[0].toLowerCase()) {
          // non-letter
          return '#' + name
        } else {
          // letter
          return name.toUpperCase()
        }
      })
    },
    groupedList() {
      const result = {}
      this.sortedList.forEach((item) => {
        let index = item['name'][0].toUpperCase()
        if (index === index.toLowerCase()) {
          // non-letter
          index = '#'
        }
        result[index] ? result[index].push(item) : (result[index] = [item])
      })
      return result
    },
    indices() {
      let me = this
      let values = [
        '#',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ]
      let result = []
      values.forEach((val) => {
        me.groupedList[val]
          ? result.push({ val, items: me.groupedList[val] })
          : result.push({ val, items: [] })
      })
      return result
    },
  },
  methods: {
    hrefForIndex(index) {
      if (index.items.length < 1) {
        return '#'
      }
      return '#agency-' + index.items[0].id
    },
  },
}
</script>

<style lang="scss" scoped>
.index-container {
  text-align: center;
  padding: 4px 4px 4px 110px;
  background: #f3eeee;
}
.index-container.top {
  border-radius: 20px 20px 0 0;
}
.index-container.bottom {
  border-radius: 0 0 20px 20px;
}
.index {
  text-decoration: none;
  color: #555;
  font-weight: bold;
  display: inline-block;
  width: 17px;
  text-align: center;
  transition: all 0.5s ease;
}
.index:hover {
  background: #ccc;
  color: black;
  border-radius: 2px;
  border-bottom: none;
  transition: all 0.2s ease;
}
.index.empty:hover {
  background: transparent;
}
.list-container {
  scroll-behavior: smooth;
  background: #e6dada;
}
.list-item {
  padding: 1em 0.5em;
  margin: 20px;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 5%);
}
.count {
  font-size: 12px;
  font-weight: 700;
  margin-top: 5px;
  margin-right: 8px;
  line-height: 16.8px;
  font-family: Helvetica Neue,Helvetica,Arial,sans-serif,-apple-system,BlinkMacSystemFont;
}
.empty {
  color: #aaa;
}
@media (max-width: 991px) {
  .index-container {
    padding-left: 4px;
  }
}
</style>